import { Link } from "react-router-dom";
import { ArrowRight, Store, Users, Megaphone, GraduationCap, Briefcase, Rocket } from "lucide-react";
import { usePageTitle } from "@/hooks/usePageTitle";

const OPPS = [
  { key: "franchise", icon: Store, title: "Franchise", copy: "Run a WeAutomate experience centre in your city. Stocking, training, and full-stack go-to-market support.", cta: "Apply for a franchise" },
  { key: "affiliate", icon: Users, title: "Affiliate / Sales partner", copy: "Refer with a unique code. Earn 10% (configurable per category) on every conversion. Real-time tracking + ledger.", cta: "Become an affiliate" },
  { key: "influencer", icon: Megaphone, title: "Influencer", copy: "Get a discount code your audience can use. They save, you earn. We handle the pipeline.", cta: "Apply as influencer" },
  { key: "learn_earn", icon: GraduationCap, title: "Learn & Earn", copy: "Pick up real skills — installation, electronics, automation, sales — and get paid while you learn.", cta: "Start Learn & Earn" },
  { key: "job", icon: Briefcase, title: "Jobs", copy: "Engineering, design, sales, ops, content — we hire for character first, credentials second.", cta: "See open roles" },
  { key: "internship", icon: Rocket, title: "Internship to Entrepreneurship", copy: "A 12-month co-branded program (WeAutomate × Milesef) that turns interns into founders inside our ecosystem.", cta: "Apply to ITE" },
];

export default function Opportunities() {
  usePageTitle(
    "Opportunities",
    "Sell, build, or partner with WeAutomate. Retailer and distributor programs, custom-build engagements, franchise opportunities, and a Learn & Earn track for creators."
  );
  return (
    <div className="py-20">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="text-[11px] uppercase tracking-widest text-white/40 font-mono">Grow with WeAutomate</div>
        <h1 className="font-display text-4xl lg:text-6xl mt-3 tracking-tighter max-w-3xl">
          Six ways to <span className="gradient-text">grow with us</span>.
        </h1>
        <p className="mt-4 text-white/60 max-w-2xl">
          Every application below flows into one pipeline, tagged by type — so no one falls through the cracks.
          Whether you want to sell, build, learn, or start something of your own, there's a way in.
        </p>
        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {OPPS.map((o) => (
            <Link to={`/opportunities/${o.key}`} key={o.key}
                  className="glass rounded-2xl p-6 hover:border-white/25 transition-colors group">
              <div className="w-10 h-10 rounded-xl bg-accent flex items-center justify-center">
                <o.icon className="w-4 h-4" />
              </div>
              <h3 className="font-display text-xl mt-5">{o.title}</h3>
              <p className="text-sm text-white/60 mt-2 leading-relaxed">{o.copy}</p>
              <div className="mt-5 text-xs uppercase tracking-widest text-white/50 font-mono flex items-center gap-1 group-hover:text-white">
                {o.cta} <ArrowRight className="w-3.5 h-3.5" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
